import store from 'store';
import { oauthConfig } from './config';

export const getStoredOAuthToken = () => {
  return store.get(oauthConfig.storageKey);
};

export const isOAuthTokenValid = (): boolean => {
  const tokenData = getStoredOAuthToken();
  if (!tokenData?.authenticated) return false;

  const { created_at, expires_in } = tokenData.authenticated;
  if (!created_at || !expires_in) return true;

  const expiresAt = (created_at + expires_in) * 1000;
  return Date.now() < expiresAt;
};

export const clearOAuthToken = (): void => {
  store.remove(oauthConfig.storageKey);
};
